module.exports = __webpack_public_path__ + "/build/web/images/testimonials-left-1-2-mobile.9dc50984070a21fc76097a48f3e5af9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-left-1-2-mobile.jpg
// module id = 194
// module chunks = 13